import { apiClient } from '../config/api';
import type {
  DigisacMessage,
  DigisacSchedule,
  SendMessageForm,
  SendTemplateForm,
  CreateScheduleForm,
} from '../types/digisac';

export class DigisacService {
  static async listMessages(params?: Record<string, string>) {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return apiClient.request<DigisacMessage[]>(`/digisac/messages${qs}`);
  }

  static async sendMessage(payload: SendMessageForm) {
    return apiClient.request<DigisacMessage>('/digisac/messages', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' },
    });
  }

  static async sendTemplate(payload: SendTemplateForm) {
    return apiClient.request<DigisacMessage>('/digisac/messages/template', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' },
    });
  }

  static async syncMessageStatus(id: string) {
    return apiClient.request<DigisacMessage>(`/digisac/messages/${id}/sync-status`, {
      method: 'POST',
    });
  }

  static async listSchedules(params?: Record<string, string>) {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return apiClient.request<DigisacSchedule[]>(`/digisac/schedules${qs}`);
  }

  static async createSchedule(payload: CreateScheduleForm) {
    return apiClient.request<DigisacSchedule>('/digisac/schedules', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' },
    });
  }

  static async cancelSchedule(id: string) {
    return apiClient.request<void>(`/digisac/schedules/${id}`, {
      method: 'DELETE',
    });
  }
}
